export function replaceEmpty(wording) {
  // replace all wording-variable values that
  // still have brackets with the value from the form
  // or empty if a field is not found
  wording = window.evite.dom.createElement(`<div>${wording}</div>`);
  const wordingSelector = wording.querySelectorAll('.wording-variable');

  if (wordingSelector) {
    const variables = Array.from(wordingSelector);
    variables.forEach((el) => {
      if (!el.innerText.match(/\[.*\]/)) {
        return;
      }
      const name = el.id.replace('var_', '');
      el.innerHTML = '';
    });
  }

  return wording.innerHTML;
}
